import localSpecialties from "@data/localSpecialties.json";
import memoizee from "memoizee";

export const isVirtual = memoizee(
  (specialtyId: string): boolean => localSpecialties.findById(specialtyId)?.isVirtual || false,
);
